import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import StandardTabs from '@ifca-root/react-component/src/components/Tabs/StandardTabs'
import {
  useGetAssignedUserByDebtorTypeQuery,
  useGetDebtorTypeQuery,
} from 'generated/graphql'
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { DebtorTypeAvailableUserForm } from './DebtorTypeAvailableUserForm'

export const DebtorTypeUserAccessListing = (props: any) => {
  let history = useHistory()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const [value, setValue] = useState(0)
  const { DebtorTypeID }: any = useParams()
  const [availableUser, setAvailableUser] = useState([])
  const [assignedUser, setAssignedUser] = useState([])
  const CompanyID = localStorage.getItem('latestCompany')
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  //API SECTION
  const {
    loading: debtorTypeLoading,
    error: debtorTypeError,
    data: { getDebtorType } = { getDebtorType: {} as any },
  } = useGetDebtorTypeQuery({
    fetchPolicy: 'network-only',
    variables: { DebtorTypeID: DebtorTypeID },
  })

  const {
    data: { getAssignedUserByDebtorType } = {
      getAssignedUserByDebtorType: [],
    },
    loading: debtorTypeAssignedLoading,
    error: debtorTypeAssignedError,
  } = useGetAssignedUserByDebtorTypeQuery({
    fetchPolicy: 'network-only',
    variables: {
      DebtorTypeID: DebtorTypeID,
    },
    // onError: ({ message }) => {
    //   let error = message?.substring(15)
    //   setErrMessage(error)
    //   setErrDialog(true)
    // },
  })

  useEffect(() => {
    if (getDebtorType && getAssignedUserByDebtorType) {
      setAssignedUser(getDebtorType[0]?.userAssigned || [])

      const assignedEntity =
        getDebtorType[0]?.userAssigned?.map(v => v.userID) || []

      const filteredUser =
        getAssignedUserByDebtorType?.filter(
          v => !assignedEntity?.includes(v?.userID)
        ) || []

      setAvailableUser(filteredUser)
    }
  }, [getDebtorType, getAssignedUserByDebtorType])

  return (
    <>
      {debtorTypeLoading && <Loading />}
      {debtorTypeAssignedLoading && <Loading />}
      <MainHeader
        mainBtn="close"
        onClick={() =>
          history.push(`/account-receivable/general-setting/debtor-type`)
        }
        smTitle={'Account Receivable'}
        title={user?.companyName}
        routeSegments={[
          { name: 'Debtor Type' },
          { name: 'User' },
          { name: 'User Access', current: true },
        ]}
        rightRouteSegments={[{ name: 'Assign', current: true }]}
      />

      <StandardTabs
        value={value}
        onChange={handleChange}
        responsive
        fullWidth
        style={{ boxShadow: 'none' }}
        tabs={[
          {
            label: `Available(${availableUser?.length})`,
            content: (
              <DebtorTypeAvailableUserForm
                user={availableUser}
                pageMode={'available'}
                companyID={getDebtorType[0]?.CompanyID}
              />
            ),
          },
          {
            label: `Assigned(${assignedUser?.length})`,
            content: (
              <DebtorTypeAvailableUserForm
                user={assignedUser}
                pageMode={'assigned'}
                companyID={getDebtorType[0]?.CompanyID}
              />
            ),
          },
        ]}
      />
    </>
  )
}
